import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Conversations Redux States
import {
  GET_CONVERSATIONS,
  GET_AGENTS,
  GET_CONVERSATIONS_FORM,
  GET_USER_FILTER,
  UPDATE_USER_FILTER,
  GET_ACTIVITY,
  GET_SKILLS,
  HANDLE_LOGOUT_AGENT,
  GET_TABS_BY_SKILL,
} from "./actionTypes";

import {
  setConversations,
  setConversationsForm,
  apiError,
  setAgents,
  setUserFilter,
  updateUserFilterSuccess,
  setActivity,
  setSkills,
  handleLogoutAgentSuccess,
  handleLogoutAgentError,
  getTabsBySkillLoading,
  getTabsBySkillSuccess,
  getTabsBySkillError,
  getAgents,
} from "./actions";

import { showToast } from "../../Libs/CustomMethods/showToast";

//Include Both Helper File with needed methods
import axios from "axios";

function* getConversations({ payload: { page, qtd, filters, order, sort } }) {
  let lastTab = [];
  if (filters?.tabs?.length > 0) {
    lastTab = [filters?.tabs[0]];
  }

  try {
    const response = yield call(
      axios.get,
      `/manager-conversations?${
        (page ? `page=${page}` : "") +
        (qtd ? `&qtd=${qtd}` : "") +
        (filters.status ? `&status=${filters.status.join()}` : "") +
        (filters.skills ? `&skills=${filters.skills.join()}` : "") +
        (filters.tabs ? `&tabs=${lastTab.join()}` : "") +
        (filters.users ? `&users=${filters.users.join()}` : "") +
        (filters.consumer ? `&consumer=${filters.consumer}` : "") +
        (filters.conversation_id ? `&id=${filters.conversation_id}` : "") +
        (filters.protocol ? `&protocol=${filters.protocol}` : "") +
        (filters.message ? `&message=${filters.message}` : "") +
        (filters.date
          ? `&dateStart=${filters.date[0]}&dateEnd=${filters.date[1]}`
          : "") +
        (filters.extras ? `&extras=${filters.extras}` : "") +
        (filters.extrasFilters
          ? `&extrasFilters=${filters.extrasFilters.join()}`
          : "") +
        (filters.personalInformation
          ? `&personalInformation=${filters.personalInformation}`
          : "") +
        (filters.personalInformationFilters
          ? `&personalInformationFilters=${filters.personalInformationFilters}`
          : "") +
        (order !== "status" ? `&order=${order}&sort=${sort}` : "")
      }`
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setConversations(response.data, qtd));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getAgentsApi({ payload: { page, qtd, filters = {} } }) {
  try {
    const apiParams = { page };

    if (filters.skills) apiParams.skills = filters.skills
    if (filters.groups) apiParams.groups = filters.groups
    if (filters.status) apiParams.status = filters.status
    if (filters.name) apiParams.name = filters.name

    const response = yield call(axios.get, "/manager-agents", {
      params: apiParams,
    });
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setAgents(response.data, qtd));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getActivity({ payload: { filters } }) {
  try {
    const apiParams = {};
    filters?.skills?.length && (apiParams.skills = filters.skills.join(","));
    filters?.groups?.length && (apiParams.groups = filters.groups.join(","));
    filters?.interval && (apiParams.interval = filters.interval);

    const response = yield call(axios.get, "/manager-activities", {
      params: apiParams,
    });
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setActivity(response.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getSkills({ payload: { filters } }) {
  try {
    const apiParams = {};
    filters?.skills?.length && (apiParams.skills = filters.skills.join(","));
    filters?.groups?.length && (apiParams.groups = filters.groups.join(","));
    filters?.interval && (apiParams.interval = filters.interval);

    const response = yield call(axios.get, "/manager-skills", {
      params: apiParams,
    });
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setSkills(response.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getTabsBySkill({ payload: { skillId } }) {
  try {
    yield put(getTabsBySkillLoading());
    const response = yield call(axios.get, `/tab/skill/${skillId}`);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(getTabsBySkillSuccess(response?.data));
    } else {
      yield put(getTabsBySkillError());
      throw response.data;
    }
  } catch (error) {
    yield put(getTabsBySkillError());
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getConversationsForm() {
  try {
    const response = yield call(axios.get, `/manager-conversations?form=true`);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setConversationsForm(response.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getUserFilter({ payload: { idUser } }) {
  try {
    const response = yield call(
      axios.get,
      `/manager-panel-filters?${idUser ? `&id=${idUser}` : ""}`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setUserFilter(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* updateUserFilter({ payload: { idUser, templateFilter } }) {
  try {
    const response = yield call(
      axios.patch,
      `/manager-panel-filters${idUser ? `?id=${idUser}` : ""}`,
      templateFilter
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(updateUserFilterSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* handleLogoutAgent({ payload: { idAgent } }) {
  try {
    const response = yield call(axios.patch, `/user/${idAgent}/logout`);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(handleLogoutAgentSuccess(idAgent));
      yield put(getAgents());
    } else throw response.data;
  } catch (error) {
    let message =
      "Sorry! something went wrong, please contact our support team";
    if (error.response && error.response.status) {
      console.error(error);
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(handleLogoutAgentError(idAgent, message));
  }
}

export function* watchLogoutAgent() {
  yield takeEvery(HANDLE_LOGOUT_AGENT, handleLogoutAgent);
}

export function* watchConversation() {
  yield takeEvery(GET_CONVERSATIONS, getConversations);
}

export function* watchAgent() {
  yield takeEvery(GET_AGENTS, getAgentsApi);
}

export function* watchActivity() {
  yield takeEvery(GET_ACTIVITY, getActivity);
}

export function* watchSkills() {
  yield takeEvery(GET_SKILLS, getSkills);
}

export function* watchGetTabsBySkill() {
  yield takeEvery(GET_TABS_BY_SKILL, getTabsBySkill);
}

export function* watchConversationForm() {
  yield takeEvery(GET_CONVERSATIONS_FORM, getConversationsForm);
}

export function* watchGetUserFilter() {
  yield takeEvery(GET_USER_FILTER, getUserFilter);
}

export function* watchUpdateUserFilterUpdate() {
  yield takeEvery(UPDATE_USER_FILTER, updateUserFilter);
}

function* authSaga() {
  yield all([
    fork(watchConversation),
    fork(watchAgent),
    fork(watchActivity),
    fork(watchSkills),
    fork(watchGetTabsBySkill),
    fork(watchConversationForm),
    fork(watchGetUserFilter),
    fork(watchUpdateUserFilterUpdate),
    fork(watchLogoutAgent),
  ]);
}

export default authSaga;
